import { SectionGroup } from 'Components/Layout';
import {
  BsCompactionCwdSection,
  BsCompactionEquipmentSection,
  BsCompactionMoistureContentDeterminationEquipmentSection,
  BsCompactionMoistureContentDeterminationGridSection,
} from 'Components/Worksheets/MaximumDryDensityWorksheet/Bs/Shared/Sections/CompactionSection';
import { BsCompactionDataSection } from './CompactionDataSection';
import BsCompactionMouldSection from './CompactionMouldSection';

const BsCompactionSection = () => (
  <>
    <BsCompactionEquipmentSection />
    <BsCompactionMouldSection />
    <SectionGroup heading="Compaction Data">
      <BsCompactionCwdSection />
      <BsCompactionDataSection />
    </SectionGroup>
    <SectionGroup heading="Water Content Determination">
      <BsCompactionMoistureContentDeterminationEquipmentSection />
      <BsCompactionMoistureContentDeterminationGridSection />
    </SectionGroup>
  </>
);

export { BsCompactionSection };
export default BsCompactionSection;
